import BaseModel from './BaseModel';

class CrmUser extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id || null;
    this.name = data.name || "";
    this.email = data.email || "";
    this.mobile_number = data.mobile_number || "";
    this.user_roles = data.user_roles || [];
    this.status = 'accepted';
    this.deleted_user_role_ids = data.deleted_user_role_ids || [];
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      crm_user: {
        name: this.name,
        email: this.email,
        mobile_number: this.mobile_number,
        user_roles_attributes: this.prepareUserRolesAttributes()
      }
    }
  }

  validations = (field) => {
    return {
      name: () => {
        if(this[field].search(/^[a-zA-Z\s'-]+$/) === -1) {
          this.errors.name = "Invalid name: Use letters only.";
        } else{
          delete this.errors.name;
        }
      },
      email: () => {
        if(this[field].search(/^.+\@.{3,}\..{2,}$/) === -1) {
          this.errors.email ="Invalid email format."
        } else{
          delete this.errors.email;
        }
      },
      mobile_number: () => {
        if(this[field].search(/^\d{10}$/) === -1) {
          this.errors.mobile_number = "Invalid mobile number format."
        } else {
          delete this.errors.mobile_number;
        }
      },
      // user_roles: () => {
      //   if(this[field].search(/^\d{10}$/) === -1) {
      //     this.errors.user_roles = "Selectany role.";
      //   } else {
      //     delete this.errors.user_roles;
      //   }
      // }
    }[field];
  }

  validate = (field) => {
    if(this.validations(field)) {
      this.validations(field)()
    }
  }

  addRole = (usersType) => {
    var userRole = this.user_roles.find((user_role) => user_role.users_type_id === usersType.id);
    if(userRole) {
      this.deleted_user_role_ids.splice(this.deleted_user_role_ids.indexOf(userRole.id), 1);
    } else {
      this.user_roles = [...this.user_roles, {
        users_type_id: usersType.id,
        status: 'accepted'
      }];
    }
  }

  removeRole = (usersType) => {
    var userRole = this.user_roles.find((user_role) => user_role.users_type_id === usersType.id);
    if(userRole.id) {
      this.deleted_user_role_ids.push(userRole.id);
    } else {
      this.user_roles.splice(this.user_roles.indexOf(userRole), 1);
    }
  }

  prepareUserRolesAttributes = () => {
    return this.user_roles.map((user_role) => {
      if(user_role.id && this.deleted_user_role_ids.indexOf(user_role.id) !== -1) {
        return { ...this.prepareUserRoleAttributes(user_role), _destroy: true }
      } else {
        return { ...this.prepareUserRoleAttributes(user_role) }
      }
    })
  }

  prepareUserRoleAttributes = (user_role) => {
    let attrs = {
      users_type_id: user_role.users_type_id,
      status: 'accepted'
    }
    if(user_role.id) {
      attrs = { ...attrs, id: user_role.id }
    }
    return attrs;
  }

  selectedUsersTypes = (usersTypes) => {
    const selectedUsersTypeIds = this.user_roles.filter((userRole) => this.deleted_user_role_ids.indexOf(userRole.id) === -1 ).map((userRole) => {
      return userRole.users_type_id
    })

    return usersTypes.filter((usersType) => selectedUsersTypeIds.indexOf(usersType.id) !== -1 )
  }

  // onChangeVehicleType = () => {

  // }

  // onChangeOffer = () => {

  // }

  // fieldsPositionalConfig = () => {
  //   return [
  //     ['name', 'email'],
  //     ['mobile_number', 'user_roles'],
  //     ['vehicle_type_id', 'offer_id'],
  //     ['from_date'],
  //   ]
  // }

  // fieldConfig = (fieldName) => {
  //   return this.fieldsConfig()[fieldName]();
  // }

  // fieldsConfig = () => {
  //   return {
  //     name: () => {
  //       return {
  //         type: 'TextField',
  //         validate: () => {
  //           if(this.name === "") {
  //             this.errors.name = "Name cannot be blank"
  //           }
  //         }
  //       }
  //     },
  //     email: () => {
  //       return {
  //         type: 'TextField',
  //         validate: () => {
  //           if(this.email.search(/^.+\@.{3,}\..{2,}$/) === -1) {
  //             this.errors.email = "Not a valid email"
  //           }
  //         }
  //       }
  //     },
  //     mobile_number: () => {
  //       return {
  //         type: 'TextField',
  //         validate: () => {
  //           if(this.mobile_number.search(/^\d{10}$/) !== -1) {
  //             this.errors.mobile_number = "Not a valid email"
  //           }
  //         }
  //       }
  //     },
  //     user_roles: () => {
  //       return {
  //         type: 'MultiSelectField',
  //         onSelect: this.addRole,
  //         onRemove: this.removeRole,
  //         selectedValues: this.selectedUsersTypes,
  //         dynamicOptions: {
  //           dependencyFields: [],
  //           apiName: 'usersTypes',
  //           dataAttr: 'users_types',
  //           labelAttr: 'role_name',
  //           valueAttr: 'id'
  //         }
  //       }
  //     },
  //     vehicle_type_id: () => {
  //       return {
  //         type: 'SelectField',
  //         onChange: this.onChangeVehicleType,
  //         dynamicOptions: {
  //           dependencyFields: [],
  //           apiName: 'vehicleTypes',
  //           dataAttr: 'vehicle_types',
  //           labelAttr: 'type',
  //           valueAttr: 'id'
  //         }
  //       }
  //     },
  //     offer_id: () => {
  //       return {
  //         type: 'SelectField',
  //         onChange: this.onChangeOffer,
  //         dynamicOptions: {
  //           dependencyFields: ['vehicle_type_id'],
  //           apiName: 'offers',
  //           dataAttr: 'offers',
  //           labelAttr: 'name',
  //           valueAttr: 'id'
  //         }
  //       }
  //     },
  //     from_date: () => {
  //       return {
  //         type: 'DateRangeField',
  //         toFieldName: 'to_date'
  //       }
  //     },
  //     to_date: () => {
  //       return {
  //         type: 'DateRangeField',
  //       }
  //     }
  //   }
  // }
}

export default CrmUser;
